export abstract class WorkerManager {
	private listeners: Map<String, ((...messageArguments: any) => void)[]>;

	constructor(private worker: Worker) {
		this.listeners = new Map();

		this.beforeListeners();

		this.addListeners();

		let manager = this;

		this.worker.onmessage = (event: MessageEvent) => {
			if (event.data instanceof Object &&
				event.data.hasOwnProperty('operation') &&
				event.data.hasOwnProperty('arguments')) {
				//console.info(`worker received operation ${event.data.operation}. listener: `, manager.listeners.get(event.data.operation));
				let handlers = this.listeners.get(event.data.operation);
				if (handlers) {
					handlers.forEach(handler => handler.apply(self, event.data.arguments));
				} else {
					//console.log('No listeners found for operation %s', event.data.operation);
				}
			} else {
				console.log('Unknown message received from worker');
			}
		}

	}

	protected beforeListeners(): void { };
	protected abstract addListeners(): void;

	public addListener(name: string, listener: (...messageArguments: any) => void): void {
		let handlers = this.listeners.get(name);
		if (!handlers) {
			handlers = [];
			this.listeners.set(name, handlers);
		}
		if (handlers.indexOf(listener) == -1) {
			handlers.push(listener);
		}
	}
	public removeListener(name: string, listener: (...messageArguments: any) => void) {
		let handlers = this.listeners.get(name);
		if (handlers) {
			let index = handlers.indexOf(listener);
			if (index !== -1) {
				handlers.splice(index, 1);
			}
			if (handlers.length === 0) {
				this.listeners.delete(name);
			}
			this.listeners.set(name, handlers);
		}
	}
	public transferMessage(transferableObjects: ArrayBuffer[], ...messageArguments: any): void {
		if (messageArguments.length < 1) {
			throw new TypeError('WorkerManager.postMessage takes at least one argument');
		}
		this.worker.postMessage({
			'operation': messageArguments[0],
			'arguments': Array.prototype.slice.call(messageArguments, 1)
		}, transferableObjects);
	}
	public postMessage(...messageArguments: any): void {
		if (messageArguments.length < 1) {
			throw new TypeError('WorkerManager.postMessage takes at least one argument');
		}
		this.worker.postMessage({
			'operation': messageArguments[0],
			'arguments': Array.prototype.slice.call(messageArguments, 1)
		});
	}
}


export abstract class MultiWorkerManager {
	private listeners: Map<String, ((...messageArguments: any) => void)[]>;

	private workers: Worker[];

	constructor(workerFactory: () => Worker, count: number) {
		this.listeners = new Map();

		let multiWorkerManager = this;
		this.workers = [];
		for (let i = 0; i < count; i++) {
			let workerIndex = i;
			let worker = workerFactory();
			worker.onmessage = (event: MessageEvent) => {
				if (event.data instanceof Object &&
					event.data.hasOwnProperty('operation') &&
					event.data.hasOwnProperty('arguments')) {
					//console.info(`worker received operation ${event.data.operation}. listener: `, manager.listeners.get(event.data.operation));
					let handlers = this.listeners.get(event.data.operation);
					if (handlers) {
						event.data.arguments.unshift(workerIndex);
						handlers.forEach(handler => handler.apply(self, event.data.arguments));
					} else {
						//console.log('No listeners found for operation %s', event.data.operation);
					}
				} else {
					console.log('Unknown message received from worker');
				}
			}
			this.workers.push(worker);
		}

		this.beforeListeners();

		this.addListeners();
	}

	protected beforeListeners(): void { };
	protected abstract addListeners(): void;

	public addListener(name: string, listener: (workerIndex: number, ...messageArguments: any) => void): void {
		let handlers = this.listeners.get(name);
		if (!handlers) {
			handlers = [];
			this.listeners.set(name, handlers);
		}
		if (handlers.indexOf(listener) == -1) {
			handlers.push(listener);
		}
	}
	public removeListener(name: string, listener: (workerIndex: number, ...messageArguments: any) => void) {
		let handlers = this.listeners.get(name);
		if (handlers) {
			let index = handlers.indexOf(listener);
			if (index !== -1) {
				handlers.splice(index, 1);
			}
			if (handlers.length === 0) {
				this.listeners.delete(name);
			}
			this.listeners.set(name, handlers);
		}
	}
	public transferMessage(workerIndex: number, transferableObjects: ArrayBuffer[], ...messageArguments: any): void {
		if (messageArguments.length < 1) {
			throw new TypeError('WorkerManager.postMessage takes at least one argument');
		}
		this.workers[workerIndex].postMessage({
			'operation': messageArguments[0],
			'arguments': Array.prototype.slice.call(messageArguments, 1)
		}, transferableObjects);
	}
	public postMessage(workerIndex: number, ...messageArguments: any): void {
		if (messageArguments.length < 1) {
			throw new TypeError('WorkerManager.postMessage takes at least one argument');
		}
		let worker = this.workers[workerIndex];
		worker.postMessage({
			'operation': messageArguments[0],
			'arguments': Array.prototype.slice.call(messageArguments, 1)
		});
	}
}
